import styles from "./NotificationBox.module.scss";
import { CustomContainer, Text } from "../../atoms/DependencyHelper";
import { createMarkup, getCookieValue } from "../../../utils/helperServices";
import LabelText from "../../atoms/label/LabelText";
import config, {
  EnvConfig,
} from "../../../config/index";

import Image from "../../atoms/image/image";
import LinkRoute from "../../atoms/linkRoute/LinkRoute";

import {
  openBreakoutUrl
} from '../../../utils/miniAppUtil';

const NotificationBox = ({
  img_path,
  labelBold,
  labelNormal,
  link = true,
  img_width,
  img_height,
  labelStyling,
  textStyle,
  className,
}) => {
  const env = config.env;
  const vodaComTermUrlPrefix = config.envConfigs[env].vodaComTermUrlPrefix;
  const isMiniApp = getCookieValue("miniApp") === "true";

  let linkRoute = <></>;

  if (link) {

    linkRoute = isMiniApp
      ? <span onClick={() => openBreakoutUrl(`${EnvConfig.serverDomain}${vodaComTermUrlPrefix}/terms-and-conditions`)}>
          <LinkRoute
            href={"javascript:void(0)"}
            className={styles["terms"]}
            text={"T&Cs apply."}
          />
        </span>
      : <LinkRoute
          href={`${vodaComTermUrlPrefix}/terms-and-conditions`}
          as={`${vodaComTermUrlPrefix}/terms-and-conditions`}
          className={styles["terms"]}
          text={"T&Cs apply."}
        />
  }

  return (
    <CustomContainer className={`${styles["delivery-container"]} ${className}`}>
      <Image
        img_path={img_path}
        img_width={img_width}
        img_height={img_height}
      />
      <LabelText className={`${styles.msg} ${labelStyling}`}>
        <span dangerouslySetInnerHTML={createMarkup(labelBold)}></span>
        <Text className={`${styles["text-style"]} ${textStyle}`}>
          <span dangerouslySetInnerHTML={createMarkup(labelNormal)}></span>
        </Text>{" "}
        {linkRoute}
      </LabelText>
    </CustomContainer>
  );
};

export default NotificationBox;
